import { sampleContent } from '../assets/sampleContent/sampleContent';
import { slugify } from './slugify';
import { statementSlug } from './statementPages';

// Small helpers the redesigned homepage shares for the 34 myth cards.

export const verdictKey = (s) => String(s.titleBadge || '').trim().toLowerCase();

const STAMP = { false: 'f', true: 't', misleading: 'm' };
export const stampClass = (s) => `fi-stamp fi-stamp--${STAMP[verdictKey(s)] || 'f'}`;

// Ticker / board badge class (filled chip, not the outlined stamp).
const BADGE = { false: 'fi-v-f', true: 'fi-v-t', misleading: 'fi-v-m' };
export const badgeClass = (s) => BADGE[verdictKey(s)] || 'fi-v-f';

export const checkNo = (s) => String(s.id).padStart(2, '0');

export const mythPath = (s) => `/idiotic-statements/${statementSlug(s.title)}`;

export const shareUrl = (s) =>
  `${typeof window !== 'undefined' ? window.location.origin : 'https://www.evsforidiots.com'}/s/${slugify(s.title)}.html`;

const firstSentence = (text) => {
  const t = String(text || '').trim();
  const m = t.match(/^(.+?[.!?])(\s|$)/);
  return m ? m[1] : t;
};

// The one-line answer: a hand-written `punch` when the card has one, else the
// first sentence of the snippet.
export const punchline = (s) => s.punch || firstSentence(s.truthSnippet);

export const mythById = (id) => sampleContent.find((s) => s.id === id);

export const verdictCounts = sampleContent.reduce((acc, s) => {
  const v = verdictKey(s);
  acc[v] = (acc[v] || 0) + 1;
  return acc;
}, {});
